export class GoogleClassroomDataSourceOptions {
    public isLoadingGoogleClassroomCourses?: boolean;
    public isGoogleClassroomReloadCoursesFeatureActive?: boolean;

    constructor(
        isLoadingGoogleClassroomCourses: boolean = null,
        isGoogleClassroomReloadCoursesFeatureActive: boolean = null,
    ) {
        this.isLoadingGoogleClassroomCourses = isLoadingGoogleClassroomCourses;
        this.isGoogleClassroomReloadCoursesFeatureActive = isGoogleClassroomReloadCoursesFeatureActive;
    }
}
